import EntityCrudPage from '../shared/EntityCrudPage';
import { accessProvisionConfig } from '../entities/access-provision/accessProvisionConfig';

const AccessProvisionPage = () => <EntityCrudPage config={accessProvisionConfig} />;

export default AccessProvisionPage;
